import React from 'react';
const ReactDropdownContext = React.createContext();
export default ReactDropdownContext;